import PropTypes from 'prop-types';

import { Upsell, StatusTag } from '@ctct/ui-react';

import upsellImage from '../../../assets/user_upsell_image.webp';

const propTypes = {
  t: PropTypes.func.isRequired,
  actions: PropTypes.node,
};

const UserUpsell = ({ t, actions }) => {
  return (
    <Upsell
      isReversed
      overline={
        <>
          <span>{t('users.upsell.overline')}</span>
          <StatusTag kind="featured" text={t('users.upsell.overline_badge')} />
        </>
      }
      backgroundColor="pink"
      image={{ url: upsellImage, alt: t('users.upsell.image_alt') }}
      imageSize="small"
      heading={t('users.upsell.heading')}
      text={t('users.upsell.text')}
      testimonials={[<>{t('users.upsell.check1')}</>, <>{t('users.upsell.check2')}</>, <>{t('users.upsell.check3')}</>]}
      subHeading={t('users.upsell.subheading')}
      data-qe-id="user-upsell"
      actions={actions}
    />
  );
};

UserUpsell.propTypes = propTypes;
export default UserUpsell;
